<template>
  <b-input-group :prepend="prepend" class="mb-2">
    <!-- <label class="sr-only" for="EBOIC">EBOIC</label> -->
    <b-form-input
      :id="id"
      :state="state"
      :pattern="pattern"
      :title="title"
      :disabled="disabled"
      :value="value"
      @change="$emit('change', $event)"
    ></b-form-input>
  </b-input-group>
</template>

<script>
export default {
  name: "InputGroup",
  props: {
    prepend: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    },
    pattern: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .form-control.is-valid {
  background-image: none;
}
#EBOIC,
#EBOE,
#EBOA,
#gross-profit-ratio,
#ROIC,
#ROE,
#ROA,
#expected-rate-of-return {
  border-color: #007bff;
  padding-right: 10px;
  width: 80px;
}
.input-group-text {
  width: 90px;
}
.input-group::after {
  content: "％";
  padding: 0.375rem;
}
</style>
